import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/rules';

export default {

    getRules(page, size, sort) {
        const params = {
            'page': page,
            'size': size,
            'sort': sort
        }
        return axios.get(BASE_URL, {params: params});
    }


}
